export default "/images/ic_pedido_entregue.svg?0b85f8f61b60f2c7e6e47edee289c826";